import React, {
  ReactDOM,
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  FilledInput,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  Box,
  TextareaAutosize,
  Grid,
  Fab,
  CardHeader,
  IconButton,
  CardContent,
} from "@mui/material";
import InventoryTracking from "../../../api/InventoryTracking";
import { AuthContext } from "../../../context/AuthContext";
import { GrabsContext } from "../../../context/GrabsContext";

import {
  Add,
  Edit,
  CheckBox,
  AddAPhoto,
  FileUpload,
  Close,
  Remove,
  Delete,
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import { TopNavContext } from "../../../context/TopNavContext";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import escapeCharacters from "../../../helpers/escapeCharacters";

import PageContent from "../../../component/PageContent";
import toFixedIfNecessary from "../../../helpers/toFixedIfNecessary";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import SelectJob from "../../../component/Selectors/SelectJob";
import SelectMaterialDialog from "./SelectMaterialDialog";

const CreateStockout = () => {
  const { jobId } = useParams();
  let navigate = useNavigate();
  const { authToken, userBranch } = useContext(AuthContext);
  const { openSnackMessage } = useContext(SnackAlertContext);
  const {
    grabFromInventory,
    grabFromBoneyard,
    grabFromCommitted,
    grabCount,
    allQuantitiesValid,
    grabs,
    updateInventoryGrabQuantity,
    removeInventoryGrab,
    updateBoneyardGrabQuantity,
    removeBoneyardGrab,
    updateCommittedGrabQuantity,
    removeCommittedGrab,
    // setDeliveryLocation,
    setStatus,
    setNotes,
    setSelectedJob,
    clearSelectedJob,
    clearGrabs,
  } = useContext(GrabsContext);

  // Image Upload
  const uploadRef = useRef(null);
  const cameraRef = useRef(null);
  const [imageDetails, setImageDetails] = useState({
    images: [],
    imageBlobs: [],
    imageUrls: [],
  });

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [loading, setLoading] = useState(false);

  // const [deliveryLocations, setDeliveryLocations] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]); // pull options is status
  const [search, setSearch] = useState("");
  const [isEditingJob, setIsEditingJob] = useState(false);
  const [isUnlisted, setIsUnlisted] = useState(false);

  const { setPageName } = useContext(TopNavContext);

  // INVENTORY SEARCH BY CATEGORY ----------------------------
  const [categorySearch, setCategorySearch] = useState("");
  const [categorySearchResults, setCategorySearchResults] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [addMore, setAddMore] = useState(false);

  // Uploads an Array Of Images
  // Returns an Array of Entity Image object with id, entity_type, image_url
  const uploadImages = async () => {
    let imageFormDataArray = [];

    let x = Math.ceil(imageDetails.imageBlobs.length / 15);
    console.log("x = ", x);
    for (let i = 0; i < x; i++) {
      let imgFormData = new FormData();
      for (
        let j = 15 * i;
        j < 15 * (i + 1) && j < imageDetails.imageBlobs.length;
        j++
      ) {
        imgFormData.append("images", imageDetails.imageBlobs[j]);
      }
      console.log(imgFormData);
      imageFormDataArray.push(imgFormData);
    }
    console.log("imageFormDataArray", imageFormDataArray);
    let imageUrls = [];
    for (let data of imageFormDataArray) {
      data.append("resourceType", "public/pull");
      let response = await InventoryTracking.post(`/uploads/images`, data, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "content-type": "multipart/form-data",
        },
      });
      imageUrls = [...imageUrls, ...response.data.files];
    }
    console.log("imageUrls uploaded", imageUrls);
    let images = [];
    for (let img of imageUrls) {
      images.push({
        image_url: img.url,
      });
    }
    return images;
  };

  const handleCategorySearch = async (controller) => {
    try {
      if (!categorySearch) {
        setCategorySearchResults([]);
        return;
      }
      setLoading(true);
      let headers = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        headers.signal = controller.signal;
      }
      const query = escapeCharacters(categorySearch);
      const response = await InventoryTracking.get(
        `/inventory?search=${query}&location=SDL&pageSize=20&page=${page}`,
        headers,
      );
      const data = {
        items: response.data.materials,
        pages: response.data.pages,
      };
      console.log(data);
      setLoading(false);
      setCategorySearchResults([...data.items]);
      setPages(data.pages);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleClearPullData = () => {
    if (jobId) {
      console.log("clearGrabs(true)");
      clearGrabs(true);
    } else {
      console.log("clearGrabs(false)");
      clearGrabs(false);
    }
  };

  // ----------------------
  // INFINITE SCROLLING
  const observer = useRef();
  const lastElement = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && page < pages) {
          console.log("visible");
          setPage((curr) => curr + 1);
        }
      });
      if (node) observer.current.observe(node);
      // console.log("NODE: ", node);
    },
    [loading, page < pages],
  );
  //

  // const getDeliveryLocations = async () => {
  //   try {
  //     const response = await InventoryTracking.get(`/delivery-locations`, {
  //       headers: {
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });
  //     console.log(response.data);
  //     setDeliveryLocations(response.data.deliveryLocations);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getStatusOptions = async () => {
    try {
      const response = await InventoryTracking.get(`/pulls/statuses`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log(response.data);
      setStatusOptions(response.data.statuses);
    } catch (error) {
      console.log(error);
    }
  };

  const submitGrabs = async (status) => {
    try {
      setLoading(true);
      if (grabs.selectedJob) grabs.project_backlog_id = grabs.selectedJob.id;

      // Remove any 0 quantity items from grabs
      let grabsCopy = { ...grabs };
      let invCopy = [];
      let boneyardCopy = [];
      let committedCopy = [];

      for (let item of grabsCopy.inventory) {
        if (item.quantity > 0) {
          invCopy.push(item);
        }
      }
      for (let item of grabsCopy.boneyard) {
        if (item.quantity > 0) {
          boneyardCopy.push(item);
        }
      }
      for (let item of grabsCopy.committed) {
        if (item.quantity > 0) {
          committedCopy.push(item);
        }
      }

      // Upload Images and Add to Object
      const newImages = await uploadImages();
      let images = [...imageDetails.images, ...newImages];
      let allImageCount = images.length;
      if (allImageCount > 30) {
        throw "You can only upload up to 30 images";
      }

      grabsCopy = {
        ...grabsCopy,
        inventory: invCopy,
        boneyard: boneyardCopy,
        committed: committedCopy,
        status: "PULLDELIVERED",
        images,
      };

      const response = await InventoryTracking.post(`/stockouts`, grabsCopy, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log(response.data);
      handleClearPullData();
      setIsUnlisted(false);
      openSnackMessage("success", "Stock Out created");
      navigate(`/daily-stockouts`);
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const grabItem = async (item, type) => {
    try {
      setLoading(true);
      let itemId = item.inventoryId;

      const response = await InventoryTracking.get(`/inventory/${itemId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      let material = response.data.material;
      console.log("MATERIAL: ", material);

      // Set Modal Data
      grabFromInventory(material, null);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    setTimeout(() => {
      handleCategorySearch(controller);
      setPage(1);
    }, 300);
    return () => {
      controller.abort(); // abort api call on unmount for cleanup
    };
  }, [categorySearch]);

  useEffect(() => {
    getStatusOptions();
  }, []);

  useEffect(() => {
    setPageName("Quick Pull");
  }, []);

  useEffect(() => {
    console.log("GRABS CONTEXT CHANGES", grabs);
  }, [grabs]);

  return (
    <PageContent
      style={{
        position: "relative",
      }}
    >
      <h2 style={{ textAlign: "center" }}>Stock Out</h2>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          size="small"
          startIcon={
            <RestartAltIcon
              style={{
                width: "40px",
                height: "40px",
              }}
            />
          }
          variant="text"
          style={{}}
          onClick={() => {
            handleClearPullData();
          }}
        >
          Restart
        </Button>
      </div>

      {/* JOB SECTION */}
      <SelectJob
        value={grabs.selectedJob}
        onUpdate={(job) => {
          if (job) {
            setSelectedJob(job.id, job.job_name, job.projectid);
            setIsUnlisted(false);
            setIsEditingJob(false);
          } else {
            clearSelectedJob();
          }
        }}
      />

      <Typography variant="h6" sx={{ marginTop: "20px" }}>
        Items
      </Typography>
      {grabs.inventory.map((grabbed, grabbedIndex) => (
        <Box
          key={grabbedIndex}
          sx={{ display: "flex", flexDirection: "row", marginTop: "16px" }}
        >
          <Typography sx={{ flex: 1 }}>{grabbed.item_description}</Typography>
          <TextField
            label="Qty To Pull"
            size="small"
            type="number"
            value={grabbed.quantity ?? ""}
            onChange={(e) => {
              updateInventoryGrabQuantity(grabbed.material_id, e.target.value);
            }}
            sx={{ width: 100 }}
          />
          <IconButton
            onClick={() => {
              removeInventoryGrab(grabbed.material_id);
            }}
          >
            <Close />
          </IconButton>
        </Box>
      ))}

      <SelectMaterialDialog
        open={addMore}
        onClose={() => {
          setAddMore(false);
        }}
        onCancel={() => {
          setAddMore(false);
        }}
        onSelect={(item) => {
          if (item) {
            grabItem(item);
            setAddMore(false);
          }
        }}
      />
      <div
        style={{
          marginTop: 16,
          marginBottom: 16,
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          style={{ width: 200, height: 70, fontSize: 24 }}
          disabled={
            loading ||
            !((grabs.selectedJob || isUnlisted) && grabCount > 0) ||
            !allQuantitiesValid
          }
          variant="contained"
          onClick={() => {
            submitGrabs();
          }}
        >
          PULLED
        </Button>
      </div>

      <Fab
        color="primary"
        aria-label="add"
        variant={isSmallScreen ? "circular" : "extended"}
        style={{
          position: "fixed",
          bottom: isSmallScreen ? 24 : 36,
          right: isSmallScreen ? 24 : 36,
          cursor: "pointer",
        }}
        onClick={() => setAddMore(true)}
      >
        <Add /> {isSmallScreen ? "" : "Material"}
      </Fab>
    </PageContent>
  );
};

export default CreateStockout;
